<template>
  <issue-probability class="issue-probability" :issue="item" :isTranslation='isTranslation'/>
</template>

<script>
import IssueProbability from '@/components/issue/IssueProbability.vue';

export default {
  name: 'IssueProbabilityTableCell',
  components: {
    IssueProbability,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    isTranslation: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
